import { timerHelperModule } from '../../../../shared/app/helpers/timer-helper';
import articleCarouselTemplate from './article-carousel.tpl.html';
import entrepreneurLogo from '../../../images/article-sources/entrepreneur.svg';
import forbesLogo from '../../../images/article-sources/forbes.svg';
import incLogo from '../../../images/article-sources/inc.svg';
import { uiBootstrapBindHtmlModule } from '../../../../shared/app/vendor/ui-bootstrap-bind-html-module';
import './article-carousel.less';

const articles = [
  {
    link: 'https://www.inc.com/andrew-medal/top-4-ways-companies-can-recruit-better-technical-talent.html',
    title: 'Top 4 Ways Companies Can Recruit Better Technical Talent',
    source: 'Inc',
    logo: incLogo,
    description:
      "Finding the right technical talent can make or break your company's success. Revamp your hiring approach with these creative, tech-driven solutions.",
  },
  {
    link: 'https://www.forbes.com/sites/julianmitchell/2017/09/26/codewars-founder-nathan-doctors-new-startup-makes-it-easy-to-recruit-top-developers/',
    title:
      "Codewars Co-Founder Nathan Doctor's New Venture Makes It Easy To Identify Top Developers",
    source: 'Forbes',
    logo: forbesLogo,
    description:
      'I spoke with Qualified CEO and Co-Founder Nathan Doctor about the vision behind his company, redefining how tech companies hire top talent, and his plans to rewrite the code of an expanding industry.',
  },
  {
    link: 'https://www.entrepreneur.com/article/307573',
    title:
      '4 Innovative Moves Entrepreneurs Can Make To Hire More Qualified Tech Experts',
    source: 'Entrepreneur',
    logo: entrepreneurLogo,
    description:
      'As the economy grows, so does the number of companies at the leading edge of innovation. Tech leaders need to start harnessing, yes, tech, to hire.',
  },
];

export const articleCarouselComponentModule = angular
  .module('Q.components.article-carousel', [
    timerHelperModule,
    uiBootstrapBindHtmlModule,
  ])

  .component('articleCarousel', {
    controller: 'ArticleCarouselCtrl',
    template: articleCarouselTemplate,
  })

  .controller(
    'ArticleCarouselCtrl',
    function ArticleCarouselCtrl($element, timerHelper) {
      const ctrl = this;

      ctrl.active = null;
      ctrl.articles = articles;
      ctrl.activeIndex = -1;
      let timer;

      const start = () => {
        if (timer) timer.start();
      };
      const stop = () => {
        if (timer) timer.stop();
      };

      ctrl.addArticle = (article) => {
        articles.push(article);
      };

      ctrl.$postLink = () => {
        timer = timerHelper.runEvery(ctrl.next, 5000);
        timerHelper.longTimeout(() => (ctrl.ready = true), 5000);
      };
      ctrl.$onDestroy = () => {
        stop();
      };

      const _prevIndex = () =>
        (ctrl.activeIndex + articles.length - 1) % articles.length;
      const _nextIndex = () => (ctrl.activeIndex + 1) % articles.length;

      ctrl.next = () => {
        ctrl.jump(_nextIndex(), { pause: false, reverse: false });
        start();
      };

      ctrl.prev = () => {
        ctrl.jump(_prevIndex(), { pause: false, reverse: true });
        start();
      };

      ctrl.jump = (index, { pause = true, reverse = null } = {}) => {
        if (index !== ctrl.activeIndex) {
          const numArticles = articles.length;
          ctrl.prevIndex = ctrl.activeIndex;
          ctrl.activeIndex = index % numArticles;
          if (reverse === null) {
            reverse = ctrl.activeIndex < ctrl.prevIndex;
          }
          ctrl.active = articles[ctrl.activeIndex];
          ctrl.reverse = reverse;
        }
        if (pause) {
          ctrl.ready = true;
          stop();
        }
      };
    },
  );
